<div class="py-3 px-3" style="background-color: white;">
    <ng-container *ngFor="let section of menuListItems">
        <div *ngIf="!section.hidden" class="profile d-flex flex-column mb-3">
            <div class="section-title">{{ section.header }}</div>
            <div class="d-flex flex-column">
                <hr class="w-100 my-1">
                <ng-container *ngFor="let item of (section.id === 'account' ? section.items : (section.expanded ? section.items : (section.items | slice:0:2)))">
                    <div *ngIf="!item.hidden" class="list-item py-1 px-3 "
                        [ngClass]="{ 'disabled-item' : item.disabled }" (click)="gotoPage(item.path)">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <span class="text-uppercase" style="font-size: 12px;">{{item.label}}</span>
                            </div>
                            <div>
                                <i *ngIf="item.icon" class="bi ml-1" [ngClass]="item.icon" style="font-size: 12px;"></i>
                            </div>
                        </div>
                    </div>
                    <hr *ngIf="!item.hidden" class="w-100 my-1">
                </ng-container>
                <button class="d-flex align-items-center" *ngIf="section.items.length > 2 && section.id !== 'account'" class="w-100 py-1"
                    style="font-size: 12px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; color: #673AB7;" (click)="section.expanded = !section.expanded">
                    <span>{{ section.expanded ? 'View less' : 'View more' }}</span> <i class="bi ml-1" [ngClass]="section.expanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
            </div>
        </div>
    </ng-container>
    
</div>


